import { SET_TRADES } from '../config/actionTypes';

const initialState = {
    trades: {},
    prices: {}
};

const StatReducer = (state = initialState, action) => {
	const { data, type } = action;
	switch (type) {
        case SET_TRADES:
			return {
                ...state,
                ...data
            };
		default:
			return state;
	}
};

export default StatReducer;
